import { StylesClasses, commonStyles, createStyles } from '@utils/styles'

const styles = createStyles({
  cardWrapper: {
    width: '100%',
    display: 'flex',
    height: { xs: 'auto', md: '536px' },
    flexDirection: { xs: 'column', md: 'column' },
    borderRadius: '12px',
    gap: '22px',
    padding: { xs: '12px', md: '20px' },
    backgroundColor: 'common.white',
  },

  imageStyles: {
    height: { xs: '232px', sm: '316px' },
    minWidth: { xs: '100%', md: '200px' },
    borderRadius: '8px',
    overflow: 'hidden',
  },

  content: {
    width: '100%',
    // height: { xs: 'calc(100% - 232px)', md: 'calc(100% - 376px)' },
    display: 'flex',
    flexDirection: 'column',
    paddingBlock: '12px',
    gap: '24px',
    justifyContent: 'space-between',
  },
  titleDesc: {
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
  },

  description: {
    ...commonStyles.getLineClampStyles(2, 50),
  },

  tag: {
    backgroundColor: 'blue.50',
    borderRadius: '20px',
    display: 'flex',
    alignItems: 'center',
    height: '20px',
    border: '1px solid',
    borderColor: 'blue.600',
    width: 'fit-content',
    padding: '4px 8px',
  },

  author: {
    display: 'flex',
    gap: '8px',
  },

  authorIcon: {
    height: '24px',
    width: '24px',
    borderRadius: '50%',
  },
  time: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: '8px',
  },
  updated: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  dot: {
    width: '4px',
    height: '4px',
    borderRadius: '100px',
    backgroundColor: 'grey.500',
    alignSelf: 'center',
  },
})

export type StylesClassNames = StylesClasses<typeof styles>
export default styles
